<template>
  <div v-if="isVisible" class="relative h-full">
    <router-link
      :to="to"
      :class="[
        'text-gray-600 hover:text-orange-500 px-2 py-3 block font-medium',
        isActive ? 'text-orange-500 font-semibold' : ''
      ]"
    >
      <slot></slot>
    </router-link>
    <div v-if="isActive" class="absolute -bottom-[1px] left-0 w-full h-[3px] bg-primary-500"></div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { canAccessRoute } from '@/utils/routeAccess'

export default {
  name: 'NavLink',
  props: {
    to: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const route = useRoute()
    const router = useRouter()

    const isActive = computed(() => {
      if (props.to === '/') return false;
      if (route.path === props.to) return true
      if (route.path.startsWith(props.to + '/')) return true
      return false
    })
    const isVisible = computed(() => canAccessRoute(props.to, router))

    return {
      isActive,
      isVisible
    }
  }
}
</script>
